import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(theme => {
  return {
    stack: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
      rowGap: theme.spacing(2),
    },
    buttonsWrapper: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      columnGap: theme.spacing(2),
    },
  };
});
